import { SvgIcon } from "@tql/ui-components-react/kendo/common";
import {
	Dialog,
	DialogActionsBar,
} from "@tql/ui-components-react/kendo/dialogs";
import { Button } from "@tql/ui-components-react/tql/buttons";
import { checkCircle } from "@tql/ui-components-react/untitled/icons";
import React from "react";

const actionContainerStyle: React.CSSProperties = {
	display: "flex",
	gap: "16px",
	justifyContent: "flex-end",
};
type ModalProps = {
	showModal: boolean;
	onToggleModal: () => void;
};
export const ConfirmationModal = ({ showModal, onToggleModal }: ModalProps) => {
	if (!showModal) return null;
	return (
		<Dialog onClose={() => onToggleModal()} title={""} width={"50%"}>
			<div className={"checkmark"}>
				<SvgIcon className={"checkmark-svg"} icon={checkCircle} />
			</div>
			<div className={"message"}>Your Quote has been saved successfully.</div>
			<DialogActionsBar>
				<div style={actionContainerStyle}>
					<Button onClick={() => onToggleModal()}>Close</Button>
				</div>
			</DialogActionsBar>
		</Dialog>
	);
};
